export interface AccountUpdateSecurityParameters {
  chas_useraccountexpiry: string;
  chas_passwordexpiry: string;
  chas_minimumpasswordlength: string;
  chas_passwordcomplexity: string;
  chas_passwordreuseprevention: string;
  chas_passwordlock: string;
}
